(() => {
  const handleize = (value) =>
    (value || '')
      .toString()
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

  const selectedValue = (group) => {
    if (!group) return '';
    const checked = group.querySelector('input:checked');
    if (checked) return checked.value;
    const select = group.querySelector('select');
    return select?.value || '';
  };

  const setControlVisibility = (control, visible) => {
    if (control.tagName === 'OPTION') {
      control.hidden = !visible;
      control.disabled = !visible;
      return;
    }

    control.hidden = !visible;
    control.disabled = !visible;
    const label = control.id ? document.querySelector(`label[for="${CSS.escape(control.id)}"]`) : null;
    if (label) label.hidden = !visible;
  };

  const syncDependentChild = (variantSelects, parentGroup, childGroup) => {
    if (!variantSelects || !parentGroup || !childGroup) return;

    const parentHandle = handleize(selectedValue(parentGroup));
    if (!parentHandle) return;

    const childControls = Array.from(
      childGroup.querySelectorAll('input[data-roseply-parent-values], option[data-roseply-parent-values]')
    );
    if (!childControls.length) return;

    const allowed = childControls.filter((control) => {
      const parents = (control.dataset.roseplyParentValues || '')
        .split(',')
        .map((item) => item.trim())
        .filter(Boolean);
      const visible = parents.includes(parentHandle);
      setControlVisibility(control, visible);
      return visible;
    });

    if (!allowed.length) return;

    const selected = childControls.find((control) =>
      control.tagName === 'OPTION' ? control.selected : control.checked
    );

    if (selected && allowed.includes(selected)) return;

    const fallback = allowed.find((control) => !control.classList.contains('disabled')) || allowed[0];
    if (fallback.tagName === 'OPTION') {
      const select = fallback.closest('select');
      if (select) {
        Array.from(select.options).forEach((option) => {
          option.selected = option === fallback;
          option.toggleAttribute('selected', option === fallback);
        });
        select.value = fallback.value;
      }
    } else {
      fallback.checked = true;
    }
  };

  const syncForEvent = (event) => {
    const variantSelects = event.target.closest?.('variant-selects');
    if (!variantSelects) return;

    const parentGroup = event.target.closest?.('[data-roseply-dependent-parent]');
    if (!parentGroup) return;

    const childGroup = variantSelects.querySelector('[data-roseply-dependent-child]');
    syncDependentChild(variantSelects, parentGroup, childGroup);
  };

  // Capture phase runs before Dawn's normal variant-selects change handler. This lets us
  // replace an invalid child choice before Shopify calculates the selected option values.
  document.addEventListener('change', syncForEvent, true);
})();
